import { render, staticRenderFns } from "./Course-roles-modal.vue?vue&type=template&id=000c5176&scoped=true"
import script from "./Course-roles-modal.vue?vue&type=script&lang=js"
export * from "./Course-roles-modal.vue?vue&type=script&lang=js"
import style0 from "./Course-roles-modal.vue?vue&type=style&index=0&id=000c5176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000c5176",
  null
  
)

export default component.exports